import { Deal, ReferenceRate } from 'api'
import { getRateFormatOptions } from '../datagrid'
import { TableCell } from './servicingDialogStyles'
import { Locale } from 'locale'
import React from 'react'

export const RateCell: React.FunctionComponent<{
  hideRateColumn: boolean
  deal: Deal
  referenceRate: ReferenceRate | null
  left?: boolean
}> = ({ hideRateColumn, deal, referenceRate, left = false }) => {
  return !hideRateColumn ? (
    <TableCell flex={2} left={left}>
      <span>{Locale.formatNumber(deal.rate, getRateFormatOptions(referenceRate))}</span>
    </TableCell>
  ) : (
    <></>
  )
}
